"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverTick = function (_Component) {
  _inherits(PopoverTick, _Component);

  function PopoverTick() {
    _classCallCheck(this, PopoverTick);

    return _possibleConstructorReturn(this, (PopoverTick.__proto__ || Object.getPrototypeOf(PopoverTick)).apply(this, arguments));
  }

  _createClass(PopoverTick, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "span",
        { className: "PopoverTick" },
        _react2.default.createElement(
          "svg",
          { className: "PopoverTick-svg", viewBox: "0 0 12 12" },
          _react2.default.createElement("path", { className: "PopoverTick-outer", d: "M0,1 H 12 L 6,12 Z" }),
          _react2.default.createElement("path", { className: "PopoverTick-inner", d: "M0.6,0 H 11.4 L 6,10 Z" })
        )
      );
    }
  }]);

  return PopoverTick;
}(_react.Component);

exports.default = PopoverTick;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/Popover/PopoverTick.js
// module id = 589
// module chunks = 0